import React from 'react';
import createReactClass from 'create-react-class';
import PurchaseSuggestionWidget from './PurchaseSuggestionWidget';
import request from '../../helpers/request';
import purchaseSuggestionConfig from './config/purchaseSuggestionConfig';
import setViewTitle from '../../helpers/setViewTitle';
import sendNotification from '../../helpers/sendNotification';
import BudgetListWidget from './BudgetListWidget';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';
import CommentsWidget from '../common/CommentsWidget';

var ConfirmPurchaseSuggestionAccounting = createReactClass({

  getInitialState() {
    return {
      lines: [],
      isValid: false,
      itemCount: 0,
      newItemCount: 0,
      orderWithoutStorage: false,
    };
  },

  componentWillMount() {
    setViewTitle('Zu genehmigender Bestellvorschlag');
  },

  handleSaveChanges() {
    var suggestion = this.suggestions.getSuggestion();

    request.put({
      url: purchaseSuggestionConfig.apiUrl + this.props.match.params.suggestionId,
      data: suggestion,
      success: () => {
        sendNotification('Die Buchhaltung wurde über die offene Genehmigung informiert.');
        this.props.history.push('/purchasesuggestions/overview');
      }
    });
  },

  handleConfirm() {
    var suggestion = this.suggestions.getSuggestion();
    suggestion.confirm = true;

    request.put({
      url: purchaseSuggestionConfig.apiUrl + this.props.match.params.suggestionId,
      data: suggestion,
      success: () => {
        sendNotification('Der Bürgermeister wurde über die offene Genehmigung informiert');
        this.props.history.push('/purchasesuggestions/overview');
      }
    });
  },

  handleReject() {
    var suggestion = this.suggestions.getSuggestion();

    request.post({
      url: purchaseSuggestionConfig.apiUrl + this.props.match.params.suggestionId + '/reject',
      data: { id: suggestion.id},
      success: () => {
        sendNotification('Der Bauhof wurde über die abgelehnte Genehmigung informiert');
        this.props.history.push('/purchasesuggestions/overview');
      }
    });
  },

  handleListStateChanges(listState) {
    this.setState({
      isValid: listState.isValid,
      itemCount: listState.itemCount,
      newItemCount: listState.newItemCount,
      orderWithoutStorage: listState.orderWithoutStorage
    });
  },

  enrichNewComment(newComment) {
    newComment.suggestionId = this.props.match.params.suggestionId;
    return newComment;
  },

  render() {
    const { isAjaxInProgress } = this.props;
    const disableSubmit = !(this.state.orderWithoutStorage || this.state.itemCount > 0 || this.state.newItemCount > 0) ||
    !this.state.isValid || isAjaxInProgress;

    const formTitle = this.state.orderWithoutStorage ? 'Neuer Bestellvorschlag ohne Lagerführung' : 'Neuer Bestellvorschlag';
    let commentsContainerClassName = 'col-sm-12 col-md-12';
    commentsContainerClassName += this.state.orderWithoutStorage ? ' col-lg-12' : ' col-lg-6';

    const footer = (
      <div>
        <footer>
          <button type="button" className="btn btn-danger" onClick={this.handleReject} disabled={isAjaxInProgress}>Ablehnen</button>
          <button type="button" className="btn btn-primary" onClick={this.handleConfirm} disabled={disableSubmit}>Genehmigen</button>
          <button type="button" className="btn btn-success" onClick={this.handleSaveChanges} disabled={disableSubmit}>Änderungen speichern</button>
        </footer>
      </div>
    );

    return (
      <div>
        <div className="row">
          <PurchaseSuggestionWidget
            ref={c => this.suggestions = c}
            suggestionId={this.props.match.params.suggestionId}
            dataUrl={purchaseSuggestionConfig.apiUrl + this.props.match.params.suggestionId}
            title={formTitle}
            onChange={this.handleListStateChanges}
            onSubmit={this.handleSubmit}
            footer={footer}
            claim="purchasesuggestions:accounting"
            documentsNodeId="documents-placeholder"
          />
        </div>
        <div className="row">
          { !this.state.orderWithoutStorage &&
            <BudgetListWidget />}
          <CommentsWidget
            apiUrl={`purchasesuggestions/${this.props.match.params.suggestionId}/comments`}
            containerClassName={commentsContainerClassName}
            beforeSubmit={newComment => this.enrichNewComment(newComment)}
            claim="purchasesuggestions:accounting"
          />
        </div>
        <div className="row" id="documents-placeholder">
        </div>
      </div>
    );
  }

});

export default AjaxInProgressHOC(ConfirmPurchaseSuggestionAccounting);



// WEBPACK FOOTER //
// ./src/components/purchasesuggestions/ConfirmPurchaseSuggestionAccounting.js